export default {
  text: '#6e6058',
  primary: '#976a4c',
  secondary: '#1c7e74',
  background: 'black',
  backgroundSecondary: '#e9dac6',
  light: '#FFF',
  dark: '#020303'
}
